import styled from 'styled-components';

const StyledSVG = styled.svg`
  .cls-1 {
    fill: #8c4c42;
  }

  .cls-1,
  .cls-2,
  .cls-3,
  .cls-4,
  .cls-5,
  .cls-6,
  .cls-7,
  .cls-8,
  .cls-9,
  .cls-10,
  .cls-11,
  .cls-12,
  .cls-13,
  .cls-14,
  .cls-15,
  .cls-16,
  .cls-17,
  .cls-18,
  .cls-19,
  .cls-20,
  .cls-21,
  .cls-22,
  .cls-23,
  .cls-24,
  .cls-25,
  .cls-26,
  .cls-27,
  .cls-28,
  .cls-29,
  .cls-30,
  .cls-31,
  .cls-32,
  .cls-33,
  .cls-34,
  .cls-35,
  .cls-36,
  .cls-37,
  .cls-38,
  .cls-39,
  .cls-40 {
    stroke-width: 0px;
  }

  .cls-2 {
    fill: #83a131;
  }

  .cls-3 {
    fill: #d0dcde;
  }

  .cls-4 {
    fill: url(#linear-gradient);
  }

  .cls-5 {
    fill: #5b913a;
  }

  .cls-6 {
    fill: #9d756f;
  }

  .cls-7 {
    fill: #d77463;
  }

  .cls-8 {
    fill: #bd4e32;
  }

  .cls-9 {
    fill: #c86d5e;
  }

  .cls-10 {
    fill: #5a3012;
  }

  .cls-11 {
    fill: #7f443b;
  }

  .cls-12,
  .cls-33 {
    fill: #d4b79f;
  }

  .cls-13 {
    fill: #793333;
  }

  .cls-14 {
    fill: #965145;
  }

  .cls-15 {
    fill: #2a170d;
  }

  .cls-41 {
    clip-path: url(#clippath-2);
  }

  .cls-42 {
    isolation: isolate;
  }

  .cls-16 {
    fill: #eff2f3;
  }

  .cls-17 {
    fill: #aa6928;
  }

  .cls-18 {
    fill: #b7cc5e;
  }

  .cls-19 {
    fill: #f6e2a0;
  }

  .cls-20 {
    fill: none;
  }

  .cls-21 {
    fill: #467428;
  }

  .cls-22 {
    fill: #f3dec9;
  }

  .cls-23 {
    fill: #ebb867;
  }

  .cls-24 {
    fill: #b56154;
  }

  .cls-25 {
    fill: #91511d;
  }

  .cls-26 {
    fill: url(#linear-gradient-2);
  }

  .cls-27 {
    fill: #42220f;
  }

  .cls-28 {
    fill: #e1a79f;
  }

  .cls-29 {
    fill: #bacbcc;
  }

  .cls-30 {
    fill: #caa5a1;
  }

  .cls-31 {
    fill: url(#linear-gradient-3);
  }

  .cls-43 {
    clip-path: url(#clippath);
  }

  .cls-32 {
    fill: #3d6820;
  }

  .cls-33 {
    mix-blend-mode: multiply;
    opacity: 0.2;
  }

  .cls-34 {
    fill: #a85f16;
  }

  .cls-35 {
    fill: #83a031;
  }

  .cls-36 {
    fill: #a75d47;
  }

  .cls-37 {
    fill: #89a743;
  }

  .cls-38 {
    fill: url(#linear-gradient-4);
  }

  .cls-39 {
    fill: #884b12;
  }

  .cls-40 {
    fill: #9f493f;
  }
`;

const TV_OMD_3D = () => {
  return (
    <StyledSVG xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 665.34 686.75">
      <defs>
        <clipPath id="clippath">
          <polygon
            className="cls-20"
            points="-271.19 24.77 -271.19 129.24 -230.28 138.9 -230.28 269.48 -396.38 365.33 -414.8 375.97 -494.34 421.88 -571.42 466.38 -571.42 198.08 -463.9 136 -463.9 165.91 -447.9 169.96 -419.87 197.32 -419.88 378.9 -374.85 352.83 -374.91 92.23 -371.34 86.98 -368.62 81 -271.19 24.77"
          />
        </clipPath>
        <clipPath id="clippath-2">
          <polygon className="cls-20" points="258.05 29.48 -577.28 511.74 -577.28 190.23 258.05 -292.04 258.05 29.48" />
        </clipPath>
        <linearGradient
          id="linear-gradient"
          x1="-197.51"
          y1="271.42"
          x2="-197.51"
          y2="432.21"
          gradientTransform="translate(11.43 -260.34) rotate(-30) scale(1 .87) skewX(-26.57)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#9d756f" />
          <stop offset="1" stop-color="#7f443b" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="-59.66"
          y1="313.99"
          x2="-6.95"
          y2="313.99"
          gradientTransform="translate(11.43 -260.34) rotate(-30) scale(1 .87) skewX(-26.57)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#bff9ef" />
          <stop offset=".16" stop-color="#bef9ef" />
          <stop offset="1" stop-color="#cdfff8" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1="-59.66"
          y1="313.99"
          x2="-6.95"
          y2="313.99"
          gradientTransform="translate(11.43 -260.34) rotate(-30) scale(1 .87) skewX(-26.57)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#9be5d5" />
          <stop offset="1" stop-color="#a7ebe4" />
        </linearGradient>
        <linearGradient id="linear-gradient-4" x1="-41.87" y1="319.14" y2="319.14" xlinkHref="#linear-gradient-3" />
      </defs>
      <g className="cls-42">
        <g id="Newspaper">
          <g className="cls-43">
            <g className="cls-41">
              <polygon
                className="cls-28"
                points="258.05 29.48 -577.28 511.74 -577.28 190.23 258.05 -292.04 258.05 29.48"
              />
              <polygon
                className="cls-4"
                points="258.05 29.48 -577.28 511.74 -577.28 350.98 258.05 -131.28 258.05 29.48"
              />
              <path
                className="cls-24"
                d="M386.9-127.43L-158.85,187.64c-6.15,3.55-11.14.67-11.14-6.43s4.99-15.74,11.14-19.29L386.9-153.15c6.15-3.55,11.14-.67,11.14,6.43,0,7.1-4.99,15.74-11.14,19.29Z"
              />
              <polygon className="cls-1" points="265 171.34 -656.72 703.49 -656.72 545.32 265 13.18 265 171.34" />
              <path
                className="cls-2"
                d="M529.15-158.12L-16.59,156.96c-6.15,3.55-11.14.67-11.14-6.43,0-7.1,4.99-15.74,11.14-19.29L529.15-183.84c6.15-3.55,11.14-.67,11.14,6.43s-4.99,15.74-11.14,19.29Z"
              />
              <path
                className="cls-19"
                d="M185.32-.14l-118.8,68.59c-6.15,3.55-11.14.67-11.14-6.43s4.99-15.74,11.14-19.29L185.32-25.86c6.15-3.55,11.14-.67,11.14,6.43s-4.99,15.74-11.14,19.29Z"
              />
              <polygon className="cls-17" points="53.47 -51.68 53.47 59.07 49.42 61.41 49.42 -49.34 53.47 -51.68" />
              <polygon className="cls-23" points="50.54 -49.99 49.42 -49.34 49.42 61.41 50.55 60.76 50.54 -49.99" />
              <polygon className="cls-10" points="53.47 -.98 53.47 3.7 49.42 6.04 49.42 1.36 53.47 -.98" />
              <polygon className="cls-10" points="53.47 38.56 53.47 43.23 49.42 45.57 49.42 40.9 53.47 38.56" />
              <polygon className="cls-10" points="53.47 45.57 53.47 50.25 49.42 52.59 49.42 47.91 53.47 45.57" />
              <polygon className="cls-10" points="53.47 52.33 53.47 57.01 49.42 59.35 49.42 54.67 53.47 52.33" />
              <polygon className="cls-39" points="33.49 -36.89 33.49 -13 -77.2 50.9 -77.2 27.01 33.49 -36.89" />
              <polygon className="cls-22" points="38.87 61.59 -80 130.22 -80 67.09 38.87 -1.54 38.87 61.59" />
              <polygon className="cls-10" points="41.27 -2.93 -83.15 68.9 -83.15 64.64 41.27 -7.19 41.27 -2.93" />
              <polygon className="cls-10" points="29.58 64.83 -42.93 106.69 -42.93 59.09 29.58 17.22 29.58 64.83" />
              <polygon className="cls-26" points="5.41 34.52 5.41 79.74 -40.23 106.09 -40.23 60.88 5.41 34.52" />
              <polygon
                className="cls-15"
                points="26.87 22.13 5.41 34.52 5.41 79.73 5.41 80.91 27.55 68.13 27.55 21.74 26.87 22.13"
              />
              <polygon
                className="cls-31"
                points="5.41 34.52 5.41 42.13 -27.16 98.54 -40.23 106.09 -40.23 103.47 -3.35 39.58 5.41 34.52"
              />
              <polygon className="cls-38" points="5.41 44.81 5.41 48.98 -21.22 95.11 -24.82 97.19 5.41 44.81" />
              <polygon className="cls-10" points="6.52 79.1 4.4 80.32 4.4 33.7 6.52 32.48 6.52 79.1" />
              <polygon className="cls-34" points="43.11 -22.92 -85.82 51.51 -85.83 66.19 43.11 -8.24 43.11 -22.92" />
              <polygon
                className="cls-33"
                points="38.87 -1.54 38.87 1.19 -13.44 91.79 -80 130.21 -80 67.09 38.87 -1.54"
              />
              <polygon className="cls-29" points="34.28 82.8 14.26 94.35 14.26 90.3 34.28 78.74 34.28 82.8" />
              <polygon className="cls-10" points="38.68 63.83 38.68 74.4 -47.64 124.24 -47.64 113.66 38.68 63.83" />
              <polygon className="cls-27" points="5.41 83.03 5.41 93.61 4.4 94.19 4.4 83.62 5.41 83.03" />
              <polygon className="cls-27" points="11.45 79.55 11.45 90.12 10.44 90.7 10.44 80.13 11.45 79.55" />
              <polygon className="cls-27" points="17.49 76.06 17.49 86.63 16.48 87.22 16.48 76.64 17.49 76.06" />
              <polygon className="cls-27" points="23.54 72.57 23.54 83.14 22.53 83.72 22.53 73.15 23.54 72.57" />
              <polygon className="cls-27" points="29.58 69.08 29.58 79.65 28.57 80.24 28.57 69.66 29.58 69.08" />
              <polygon className="cls-27" points="35.62 65.59 35.62 76.17 34.61 76.75 34.61 66.18 35.62 65.59" />
              <polygon className="cls-12" points="41.28 64.46 -47.64 115.8 -47.64 111.54 41.28 60.2 41.28 64.46" />
              <polygon className="cls-12" points="41.28 76.11 -47.64 127.45 -47.64 124.24 41.27 72.9 41.28 76.11" />
              <polygon className="cls-27" points="41.28 61.27 -47.64 112.61 -47.64 111.54 41.28 60.2 41.28 61.27" />
              <polygon className="cls-27" points="25.87 69.62 22.66 71.48 22.66 7.82 25.87 5.96 25.87 69.62" />
              <polygon className="cls-16" points="41.27 43.92 -47.64 95.25 -47.64 90.99 41.27 39.66 41.27 43.92" />
              <polygon className="cls-16" points="41.28 60.2 -47.64 111.54 -47.64 107.28 41.28 55.94 41.28 60.2" />
              <polygon className="cls-16" points="12.33 75.74 8.63 77.88 8.63 60.63 12.33 58.5 12.33 75.74" />
              <polygon className="cls-17" points="33.49 -33.98 33.49 -32.81 -77.2 31.09 -77.2 29.93 33.49 -33.98" />
              <polygon className="cls-17" points="33.49 -29.9 33.49 -28.73 -77.2 35.17 -77.2 34.01 33.49 -29.9" />
              <polygon className="cls-17" points="33.49 -25.82 33.49 -24.66 -77.2 39.25 -77.2 38.09 33.49 -25.82" />
              <polygon className="cls-17" points="33.49 -21.74 33.49 -20.58 -77.2 43.33 -77.2 42.17 33.49 -21.74" />
              <path
                className="cls-21"
                d="M115.1,16.26c2.07-6.03,3.42-13.6,3.58-21.29.02-.52.02-1.04.02-1.57,0-2.44-.12-4.74-.36-6.88-.26-2.6-.72-4.92-1.3-6.92-.58-2.14-1.33-3.91-2.19-5.28-1.93-3.22-4.48-4.36-7.3-2.73-6.16,3.55-11.14,19.08-11.14,34.67,0,8.24,1.39,14.81,3.6,18.7l15.08-8.71Z"
              />
              <path
                className="cls-32"
                d="M107.29,20.77V-28.23c-6.04,3.85-10.88,19.13-10.88,34.5,0,8.24,1.4,14.81,3.62,18.69l7.27-4.2Z"
              />
              <path
                className="cls-35"
                d="M118.7-6.6c0,.53,0,1.06-.02,1.57l-4.09,7.09c-1.08,1.88-2.84,2.89-3.92,2.27-.53-.31-.82-.97-.82-1.81s.28-1.78.82-2.72l7.68-13.27c.24,2.14.36,4.43.36,6.88Z"
              />
              <path
                className="cls-21"
                d="M100.77,24.53c1.55-4.53,2.57-10.22,2.69-16,.02-.39.02-.78.02-1.18,0-1.83-.09-3.56-.27-5.17-.2-1.96-.54-3.7-.98-5.2-.44-1.61-1-2.93-1.65-3.96-1.45-2.42-3.37-3.27-5.49-2.05-4.63,2.68-8.38,14.35-8.37,26.06,0,6.19,1.05,11.14,2.71,14.06l11.34-6.55Z"
              />
              <path
                className="cls-32"
                d="M94.89,27.93V-8.9c-4.54,2.9-8.18,14.38-8.18,25.94,0,6.19,1.05,11.13,2.72,14.05l5.46-3.15Z"
              />
              <path
                className="cls-35"
                d="M102.23-3.02l-2.83,4.89c-.81,1.41-2.14,2.17-2.95,1.7-.4-.25-.62-.73-.62-1.34,0-.62.22-1.38.62-2.07l4.13-7.15c.65,1.03,1.21,2.35,1.65,3.96Z"
              />
              <path
                className="cls-35"
                d="M103.47,7.35c0,.4,0,.8-.02,1.18l-3.08,5.33c-.81,1.4-2.14,2.17-2.95,1.7-.4-.23-.61-.73-.61-1.36s.21-1.33.62-2.05l5.77-9.98c.18,1.61.27,3.33.27,5.17Z"
              />
              <polygon
                className="cls-22"
                points="233.29 -50.66 114.43 17.97 114.43 -45.16 233.29 -113.79 233.29 -50.66"
              />
              <polygon className="cls-25" points="131.66 -5.72 117.91 2.21 117.91 -7.41 131.66 -15.35 131.66 -5.72" />
              <path
                className="cls-18"
                d="M130.6-4.14c0,1.17-.82,2.6-1.84,3.18l-8.01,4.62c-1.02.59-1.84.11-1.84-1.06v-11.05c0-1.17.82-2.6,1.84-3.18l8.01-4.63c1.01-.59,1.84-.11,1.84,1.06V-4.14Z"
              />
              <polygon className="cls-37" points="130.6 -.27 118.92 6.48 118.92 1.07 130.6 -5.68 130.6 -.27" />
              <polygon className="cls-18" points="130.6 -1.15 118.89 5.62 118.89 1.65 130.6 -5.11 130.6 -1.15" />
              <polygon className="cls-17" points="118.92 2.98 116.29 4.49 116.29 -.92 118.92 -2.44 118.92 2.98" />
              <polygon className="cls-25" points="118.92 6.48 116.29 7.99 116.29 2.58 118.92 1.07 118.92 6.48" />
              <polygon className="cls-25" points="133.23 2.93 116.29 12.71 116.29 7.99 133.23 -1.78 133.23 2.93" />
              <polygon className="cls-25" points="150.99 -7.37 134.06 2.41 134.06 -2.31 150.99 -12.08 150.99 -7.37" />
              <polygon className="cls-29" points="185.81 -4.69 165.79 6.87 165.79 2.82 185.81 -8.74 185.81 -4.69" />
              <polygon
                className="cls-33"
                points="233.3 -113.79 233.3 -111.06 180.98 -20.46 114.43 17.96 114.43 -45.16 233.3 -113.79"
              />
              <polygon className="cls-10" points="233.1 -48.42 233.11 -37.85 146.79 11.99 146.79 1.41 233.1 -48.42" />
              <polygon className="cls-27" points="151.49 -1.31 151.5 9.27 150.49 9.85 150.49 -.72 151.49 -1.31" />
              <polygon className="cls-27" points="157.54 -4.8 157.54 5.78 156.53 6.36 156.53 -4.21 157.54 -4.8" />
              <polygon className="cls-27" points="163.58 -8.28 163.58 2.29 162.57 2.88 162.57 -7.7 163.58 -8.28" />
              <polygon className="cls-12" points="235.7 -47.78 146.78 3.55 146.78 -.71 235.7 -52.05 235.7 -47.78" />
              <polygon className="cls-12" points="235.7 -36.14 146.78 15.2 146.78 11.99 235.7 -39.34 235.7 -36.14" />
              <polygon className="cls-3" points="146.78 -.71 114.43 17.97 114.43 13.71 146.78 -4.97 146.78 -.71" />
              <polygon className="cls-29" points="146.78 3.55 114.43 22.23 114.43 15.84 146.78 -2.84 146.78 3.55" />
              <polygon className="cls-3" points="146.78 6.46 114.43 25.14 114.43 20.87 146.78 2.19 146.78 6.46" />
              <polygon className="cls-29" points="146.78 10.71 114.43 29.39 114.43 23 146.78 4.33 146.78 10.71" />
              <polygon className="cls-3" points="146.78 13.59 114.43 32.27 114.43 28.01 146.78 9.33 146.78 13.59" />
              <polygon className="cls-29" points="146.78 17.84 114.43 36.52 114.43 30.14 146.78 11.46 146.78 17.84" />
              <polygon className="cls-27" points="235.7 -50.98 146.78 .36 146.78 -.71 235.7 -52.05 235.7 -50.98" />
              <polygon className="cls-16" points="110.38 -.24 115.32 -3.09 115.32 1.16 110.38 4.02 110.38 -.24" />
              <polygon className="cls-27" points="111.28 3.5 114.43 1.68 114.43 36.52 111.28 38.34 111.28 3.5" />
              <polygon className="cls-10" points="98.95 69.2 104.66 65.9 104.66 72 98.95 75.3 98.95 69.2" />
              <path
                className="cls-21"
                d="M125.07,46.86c-.28.52-.57,1.01-.87,1.51-4.22,6.93-10.4,11-14.28,9.2-4.14-1.92-4.08-9.83.13-17.67,4.22-7.84,10.99-12.63,15.13-10.71,1.68.78,2.67,2.56,2.97,4.9.18,1.4.11,3.02-.21,4.77-.23,1.31-.61,2.69-1.13,4.1-.46,1.28-1.05,2.59-1.75,3.9Z"
              />
              <path
                className="cls-32"
                d="M124.84,29.06c-4.17-1.51-10.68,3.21-14.78,10.83-4.1,7.62-4.26,15.3-.45,17.48l15.23-28.31Z"
              />
              <path
                className="cls-5"
                d="M117.75,40.79c.41-.75,1.1-1.2,1.55-.99h0c.45.21.49.99.08,1.74l-11.09,20.63c-.41.75-1.1,1.2-1.55.99h0c-.45-.21-.49-.99-.08-1.74l11.1-20.63Z"
              />
              <path
                className="cls-35"
                d="M127.96,38.86l-6.42,1.68c-.3.08-.57.05-.78-.05-.54-.24-.8-.98-.6-1.95.3-1.38,1.38-2.73,2.43-2.99l5.57-1.46c.18,1.4.11,3.02-.21,4.77Z"
              />
              <path
                className="cls-35"
                d="M125.07,46.86c-.28.52-.57,1.01-.87,1.51l-7.98,2.07c-.31.08-.58.07-.81-.04-.52-.24-.77-.99-.58-1.96.3-1.38,1.38-2.71,2.43-2.99l9.56-2.49c-.46,1.28-1.05,2.59-1.75,3.9Z"
              />
              <path
                className="cls-21"
                d="M111.91,38.99c0,.48-.03.97-.06,1.46-.53,6.91-4.83,14.54-10.05,17.55-5.58,3.22-10.1-.07-10.1-7.34,0-7.27,4.52-15.78,10.1-19,2.27-1.31,4.36-1.54,6.05-.87,1.01.4,1.88,1.13,2.55,2.14.51.76.9,1.69,1.15,2.77.24.97.37,2.07.37,3.28Z"
              />
              <path
                className="cls-32"
                d="M101.35,31.96c-5.37,3.4-9.65,11.63-9.65,18.71,0,7.08,4.28,10.36,9.65,7.57v-26.28Z"
              />
              <path
                className="cls-5"
                d="M100.51,43.6c0-.7.49-1.55,1.09-1.9h0c.61-.35,1.1-.07,1.1.63v19.14c0,.7-.49,1.55-1.1,1.9h0c-.6.35-1.1.07-1.1-.63v-19.14Z"
              />
              <path
                className="cls-35"
                d="M110.39,32.94l-5.94,6.89c-.28.32-.58.57-.87.74-.72.42-1.42.37-1.78-.22-.48-.85-.09-2.45.88-3.57l5.16-5.98c1.01.4,1.88,1.13,2.55,2.14Z"
              />
              <path
                className="cls-35"
                d="M111.91,38.99c0,.48-.03.97-.06,1.46l-7.4,8.56c-.28.32-.58.58-.88.76-.71.41-1.41.34-1.76-.24-.48-.85-.09-2.44.88-3.57l8.86-10.25c.24.97.37,2.07.37,3.28Z"
              />
              <path
                className="cls-21"
                d="M92.78,49.98c.3.15.58.33.85.53,3.82,2.74,4.15,9.69.59,16.16-3.8,6.9-10.62,10.64-15.23,8.34-4.61-2.3-5.26-9.77-1.45-16.67,1.55-2.81,3.59-5.09,5.78-6.66,1.31-.94,2.68-1.62,4.02-2.01,1.01-.29,2.01-.41,2.96-.34.87.06,1.7.26,2.47.65Z"
              />
              <path
                className="cls-32"
                d="M77.25,58.91c-3.47,6.74-2.74,13.86,1.74,16.1,4.48,2.24,11.04-1.25,14.9-7.79l-16.65-8.31Z"
              />
              <path
                className="cls-5"
                d="M83.74,63.48c-.44-.22-.46-1.01-.05-1.76h0c.41-.75,1.11-1.18,1.55-.96l12.12,6.05c.45.22.47,1.01.05,1.76h0c-.41.75-1.11,1.18-1.55.95l-12.13-6.05Z"
              />
              <path
                className="cls-35"
                d="M87.35,49.67l-1.86,8.45c-.09.39-.26.8-.45,1.16-.49.89-1.25,1.61-2,1.8-1.04.24-1.65-.68-1.33-2.07l1.62-7.33c1.31-.94,2.68-1.62,4.02-2.01Z"
              />
              <path
                className="cls-35"
                d="M92.78,49.98c.3.15.58.33.85.53l-2.33,10.52c-.09.4-.24.8-.45,1.18-.49.88-1.26,1.59-2,1.78-1.04.24-1.64-.68-1.33-2.07l2.78-12.59c.87.06,1.7.26,2.47.65Z"
              />
              <path
                className="cls-17"
                d="M108.34,61.86c0,2.06-1.44,4.58-3.24,5.62l-6.69,3.86c-1.79,1.03-3.24.19-3.24-1.87,0-1.04.37-2.19.95-3.21.58-1.01,1.39-1.9,2.29-2.42l6.69-3.86c1.8-1.04,3.24-.19,3.24,1.89Z"
              />
              <path
                className="cls-23"
                d="M99.13,63.42v7.5l-.72.42c-1.79,1.03-3.24.19-3.24-1.87,0-1.04.37-2.19.95-3.21.58-1.01,1.39-1.9,2.29-2.42l.72-.42Z"
              />
            </g>
          </g>
          <path
            className="cls-28"
            d="M594.31,216.59c.86.16,1.71.32,2.57.47,1.83,3.03,4.4,1.66,6.83,1.16,1.05.12,2.09.24,3.14.37,1.78,3.09,4.3,2.58,6.95,1.43.69.09,1.37.18,2.06.27.97,2.21,2.82,1.37,4.46,1.3.53.08,1.06.15,1.59.23,6.23,3.49,11.79,7.86,16.78,12.97.25.22.34.5.28.82.8,2.47.11,5.54,2.95,7.17.06.5.11,1.01.17,1.51-.5,40.81.18,81.62-.09,122.43-2.55,1.19-2.1,3.53-2.1,5.65-.02,25.31-.03,50.63-.02,75.94,0,1.47-.33,3.02.75,4.32-.07,12.35-.15,24.71-.22,37.06-1.63.58-1.53,1.98-1.52,3.3.06,18.38.12,36.75.18,55.13-.07,1.53-.14,3.06-.22,4.59-2.98,5.21-4.24,11.24-7.82,16.16,0,0,.03-.04.03-.04-2.03-.12-3.01.91-3.16,2.87,0,0,0,0,0,0-2.79.52-5.18,1.58-6.04,4.62-.81.53-1.61,1.07-2.42,1.6-4.11.82-7.06,3.34-9.56,6.51-.61.44-1.21.89-1.82,1.33-3.6-.23-5.42,2.23-7.17,4.78-1.16.7-2.31,1.4-3.47,2.09-1.6.4-3.11.9-3.54,2.79-.61.45-1.21.9-1.82,1.35-1.17-.1-1.96.33-2.19,1.56-.22.27-.5.41-.85.42-2.31.33-4.46.89-5.15,3.57-.09.31-.3.49-.63.52-2.05-.3-3.17,1.05-4.28,2.42-.73.47-1.47.94-2.2,1.41-.95,0-1.9,0-2.85.01-3.59.6-6.17,3.17-9.2,4.82-5.57,3.04-10.18,2.37-15.13-1.53-4.84-3.82-5.44-9.2-5.52-14.34-.22-101.61,1.68-203.21.85-304.83,0-19.65-.02-39.29.01-58.94.01-9.5,6.73-17.06,16.04-18.07,1.42-.15,2.67-.29,2.94-2.01,1.68.34,3.35.69,5.03,1.03.15,2.31,2.73,2.37,2.9.12,5.08.09,9.64,3.8,14.96,2.12,1.03.18,2.06.35,3.08.53,1.15,1.77,2.85,1.14,4.44,1.01ZM550.89,570.62c0,10.99.08,21.99-.04,32.98-.05,4.18,1.54,6.12,5.85,6.13,6.62.01,11.42-4.42,11.11-11.81-.56-13.44,1.12-26.81.31-40.28-.69-11.4.13-22.9.56-34.37,1.02-60.29.71-120.64,2.17-180.95.77-35.08,1.52-70.2,1.11-105.33.02-3.36-1.16-6.3-2.68-8.97-8.16-13.95-23.22-2.59-22.37,10.38.38,14.62-.16,29.23.75,43.88,1.2,19.23.23,38.55,1,57.85.72,18.17-.65,36.42-.68,54.64,1.42,48.29.02,96.62,2.8,144.89.65,10.29.1,20.65.11,30.98ZM594.92,311.74c0-.05,0-.11,0-.16-3.46.16-6.94.17-10.38.55-1.09.12-3.08.15-2.98,1.92.09,1.66,1.8,1.7,3.11,1.68,2.8-.04,5.6.25,8.39-.49,2.92-.78,5.87-1.11,8.33,1.41,2.24,2.35,5.07-.12,4.42-2.94-.24-1.75-1.55-1.95-2.94-1.96-2.65-.02-5.3,0-7.94,0ZM601.69,372.41c1.97.55,3.41-.2,3.68-2.15.33-2.42-1.65-2.53-3.32-2.52-6.6.05-12.94,1.86-19.36,3.11-1.91.17-1.9,2.74.02,2.75,1.64-.03,3.27-.18,4.9-.31,4.69-.35,9.27-2.47,14.07-.89Z"
          />
          <path
            className="cls-9"
            d="M145.02,222.39c.71-.11,1.43-.21,2.14-.32,2.96,1.05,5.9,1.32,8.79-.22,6.17-.45,12.34-.91,18.54-.37,3.43.1,6.87.48,10.27.22,2.75-.21,5.9,1.42,8.26-1.32,4.67-.83,9.38-.43,14.08-.45,1.42,1.28,3.2.99,4.77.78,7.28-.95,14.58-.87,21.89-1,.74-.01,1.47-.62,2.2-.95,7.04-.81,14.1-1.06,21.18-.71,1.63,1.21,3.52.83,5.25.58,8.61-1.23,17.25-1.83,25.94-1.99,2.21-.04,4.42,1.5,6.61.06,6.34-.56,12.8,1.19,19.05-1,1,.03,2,.06,3.01.09.71.91,1.36.83,1.97-.1,2.34,0,4.68,0,7.02,0,3.34,1.58,6.66,1.73,9.97-.08,6.62-1.52,13.35-.54,20.02-.87,3.14,1.12,6.3,2.39,9.04-.83,8.63-.1,17.25-.21,25.88-.31,4.03-.41,8.32,1.63,12.09-1.28,3.7-.1,7.39-.19,11.09-.29,10.03,1.62,19.94.59,29.82-1.32,3.52-.12,7.04-.23,10.57-.35,5.04,1,10.13.27,15.19.34,1.8.03,4.03.95,5.32-1.35,6.02-.12,12.05-.25,18.07-.37,1.28,1.11,2.86.85,4.3.72,8.11-.71,16.23-.98,24.36-1.02.72,0,1.45-.64,2.17-.98,4.2-.71,8.42-.39,12.64-.28,1.43.39,2.85.69,4.22-.2,1.37.12,2.74.25,4.11.37,1.49,2.27,4.48.26,6.12,2.14-.94,1.94-2.94,2.67-4.57,3.69-3.7,2.3-7.65,4.65-9.67,8.39-3.61,6.7-8.83,8.62-15.99,8.05-11.17-.87-2.54,8.47-5.83,14.1-1.3-.17-2.59-.33-3.89-.5-.37-1.14-1.16-1.15-2.27-1.26-7.57-.72-15.14-.28-22.71-.3-6.38-.04-12.76-.1-19.14-.12-1.59,0-3.4-.35-4.02,1.83-43.38,0-86.75,1.8-130.14,2.92-73.97,1.81-147.96,3.62-221.9,5.07-16.81-.05-33.57,1.34-50.37,1.16-2.8-.03-4.9.86-5.54,3.88-3.24,1.19-1.31,4.11-2.05,6.14-4.29-3.34-5.48-7.96-5.88-13.14-.49-6.45,1.35-12.73.97-19.14,1.44-1.94,3.29-3.06,5.77-2.92,1.29.27,2.56.47,3.34-.99,1.04-.17,2.08-.33,3.12-.5,1.56.96,2.98,1.28,3.86-.86,14.32-1.31,28.7-.49,43.03-.53,2.65-.15,5.66,1.36,7.96-1.22,4-.97,8.07-.32,12.1-.46,6,.88,12,1.96,17.88-.62Z"
          />
          <path
            className="cls-9"
            d="M514.89,243.96c3.29-5.62-5.34-14.97,5.83-14.1,7.16.57,12.38-1.35,15.99-8.05,2.02-3.74,5.97-6.09,9.67-8.39,1.64-1.02,3.63-1.75,4.57-3.69,1.01-.01,2.08.17,2.87-.72.68.07,1.36.13,2.03.2,1.69,2.73,4.25,1.24,6.48,1.32.52.07,1.04.15,1.56.22,0,.34,0,.68,0,1.02-.27,1.72-1.51,1.86-2.94,2.01-9.32,1.01-16.03,8.57-16.04,18.07-.03,19.65,0,39.29,0,58.94.82,101.62-1.08,203.22-.86,304.83.09,5.14.68,10.52,5.52,14.34,4.95,3.9,9.56,4.56,15.13,1.53,3.04-1.65,5.61-4.22,9.2-4.82-.02.89-.04,1.78-.06,2.68-.21.27-.48.4-.82.4-3.67.68-6.42,2.6-8.1,5.98l-.23.21s-.31,0-.31,0c-1.33-.26-2.24.13-2.5,1.56-1.6,1.1-3.19,2.19-4.79,3.29-1.05-.14-1.84.18-2.25,1.22-.67.18-1.33.36-2,.53-.62-.25-1.23-.51-1.85-.76-4.04-1.33-8.17-2.44-12.1-4.03-5.67-2.29-11.22-4.63-17.45-5.27-7.56-.78-15.08-2.01-22.56-3.36-12.99-2.34-25.86-5.53-38.93-7.22-13.79-1.79-27.26-5.13-40.97-7.25-7.67-1.18-15.29-2.68-22.94-4-1.42-.24-2.69-.64-2.82-2.26-.09-1.03.67-1.29,1.67-1.2,31.97,2.59,63.86,6.05,95.77,9.18,3.93.33,8.26,1.63,11.19-2.63,3.27-.39,7.04.62,9.15-2.78,3.3-1.02,4.07-3.5,4.03-6.63-.22-19.8.31-39.6.81-59.39.75-29.79-.3-59.58.78-89.39.56-60.58,1.57-121.21,1.31-181.82.01-3.64-.79-6.9-3.05-9.77Z"
          />
          <path
            className="cls-9"
            d="M501.85,593.75c-2.93,4.26-7.26,2.96-11.19,2.62-31.92-3.13-63.8-6.58-95.77-9.18-1-.09-1.76.17-1.67,1.2.14,1.62,1.4,2.01,2.82,2.26,7.65,1.31,15.27,2.81,22.94,4,13.71,2.12,27.18,5.46,40.97,7.25,13.07,1.69,25.94,4.88,38.93,7.22,7.48,1.35,15,2.58,22.56,3.36,6.23.64,11.78,2.99,17.45,5.27,3.94,1.59,8.06,2.7,12.1,4.03-.04.56-.07,1.12-.11,1.67-.89.16-1.79.32-2.68.48-2.52-.09-5.2-1.38-7.37,1.01-.62,0-1.25.02-1.87.03-2.87-2.56-6.19-1.07-9.35-1.05-1.26-.1-2.51-.21-3.77-.31-2.42-1.5-4.89-2.69-7.79-1.32-1.36-.16-2.72-.31-4.07-.47-1.86-1.96-4.14-1.11-6.32-.94-2.57-.22-5.14-.44-7.7-.65-1.42-2.57-3.57-1.42-5.56-1.1-1.17-.12-2.33-.24-3.5-.36-2.48-1.34-5.01-2.39-7.89-1.29-1.68-.16-3.36-.31-5.04-.47-1.04-1.95-2.74-1.28-4.32-1.09-1.14,0-2.27,0-3.41,0-3.36-1.1-6.74-2.13-10.31-2.36-.28-1.24-.63-2.31-2.03-.84-2.32-.08-4.65-.17-6.97-.25-2.14-2.99-5.14-2.1-8.01-1.78-.99,0-1.98.02-2.96.02-4.02-3.88-9.6-2.78-14.29-3.69-10.83-2.09-22.01-2.33-32.96-4.2-3.1-.53-6.57-.96-9.7.67-1.02-.1-2.04-.21-3.05-.31-2.94-3.07-6.33-3.23-10.01-1.53-1-.05-1.99-.1-2.99-.15-1.8-3.25-4.41-1.77-6.87-1.18-1.38-.15-2.76-.3-4.14-.46-2.29-2.63-4.96-2.92-7.95-1.32-1.34-.07-2.69-.13-4.03-.2-.41-1.9-2.17-1.98-3.5-2.3-5.73-1.39-11.69-1.57-17.38-3.34-6.54-2.04-13.44-.92-20.16-1.76-4.15-.52-8.64-3.07-12.97-.26-.66-.07-1.32-.14-1.98-.2-.16-1.03-.5-2.16-1.53-2.38-6.11-1.32-12.25-2.59-18.46-.49-.67-.07-1.34-.13-2.01-.2-1.8-3.76-5.73-3.61-8.65-3.56-11.06.19-21.37-4.05-32.26-4.8-3.81-.26-7.81.54-11.39-.65-9.45-3.12-19.58-1.31-29.04-4.6-4.88-1.7-10.34-1.48-15.48-2.22-31.18-4.9-62.4-9.83-93.68-14.09-5.66-.67-11.51-.65-17.02-2.55-4.62-1.6-9.19-8.8-8.32-13.47.38-2.06,1.02-5.07,4.05-2.89,6.82,4.91,14.8,4.19,22.39,4.99,12.01,1.27,24,2.65,35.97,4.28,6.39.87,12.89,3.04,19.48.81,1.33,0,2.66,0,4,0,2.35,3.18,4.68,3.2,7-.03,21.67,1.33,43.05,5.36,64.58,7.96,27.17,2.96,54.27,6.43,81.36,10.07,46.28,6.19,92.69,11.42,138.92,17.92,24.69,2.81,49.35,5.83,73.97,9.14Z"
          />
          <path
            className="cls-9"
            d="M132.02,548.69c-6.58,2.22-13.08.06-19.48-.81-11.97-1.63-23.96-3.02-35.97-4.28-7.58-.8-15.57-.08-22.39-4.99-3.02-2.18-3.66.83-4.05,2.89-.87,4.67,3.7,11.88,8.32,13.47,5.51,1.9,11.35,1.88,17.02,2.55,31.28,4.27,62.5,9.2,93.68,14.09,5.14.74,10.6.52,15.48,2.22,9.46,3.29,19.59,1.48,29.04,4.6,3.58,1.18,7.58.38,11.39.65,10.89.75,21.2,5,32.26,4.8,2.93-.05,6.85-.2,8.65,3.56-10.16-.09-20.05-2.5-30.09-3.62-25.76-3.23-51.44-7.29-77.21-10.56-2.69-.39-4.18.53-5.81,2.58-8.08,10.12-16.32,20.1-24.56,30.08-1.44,1.75-2.66,3.89-5.21,4.36-.16-1.42-.63-2.31-2.33-2.64-5.56-1.07-6.12-2.33-3.09-7.25,4.59-7.43,9.46-14.69,14.01-22.15,1.48-2.44,5.39-4.55,3.84-7.47-1.68-3.17-5.9-1.9-9.11-2.08-.44-.09-.89-.17-1.33-.26-1.55-2.65-3.73-1.87-5.91-1.09-.7-.11-1.41-.21-2.11-.32-2.77-2.37-6.02-1.1-9.09-1.21-1.98-.18-3.96-.35-5.93-.53-1.38-2.58-3.54-1.35-5.5-1.12-1.18-.09-2.37-.18-3.55-.27-2.38-1.87-4.91-2.92-7.87-1.31-1.68-.15-3.37-.3-5.05-.45-1.76-2.45-4.16-1.2-6.36-1.11-.91-.09-1.83-.17-2.74-.26-2.72-1.89-5.6-2.75-8.82-1.3-.7-.08-1.4-.15-2.1-.23-.58-1.65-1.84-1.61-3.21-1.31-.28-.22-.57-.44-.85-.65-.33-.15-.66-.31-1-.47-11.57-6.39-14.72-16.84-14.81-29.24-.34-42.94-.75-85.88-1.55-128.81-.7-37.27-1.36-74.55-1.56-111.83-.07-12.98-1.04-25.99.22-38.92.71-7.23,3.77-13.7,10.66-17.49.37,6.41-1.46,12.69-.97,19.14.4,5.18,1.59,9.8,5.88,13.14-.13,88.9,3.42,177.77,3.09,266.69-.26,5.27,2.13,8.11,7.06,9.19.98,1.2,1.99,1.22,3.02.06,1.66.05,3.32.11,4.97.16.36,1.85,1.75,1.82,3.17,1.72,3.61.08,7.21.16,10.82.24,1.2,2.77,3.04,2.14,4.99.94,5.87,1.81,11.9,2.12,17.98,2,1.56,3.12,3.8,2.03,6.04.97,5.98.75,11.88,2.24,17.96,2.08.02.61.03,1.23.05,1.84Z"
          />
          <path
            className="cls-28"
            d="M355.97,214.76c-6.67.33-13.4-.65-20.02.87-3.33-1.26-6.66-1.4-9.97.08-2.34,0-4.68,0-7.02.01-.7-.86-1.36-.83-1.97.1-1-.03-2-.06-3.01-.09-2.14-4.34.24-6.27,3.92-7.84,7.35-3.13,15.31-3.39,22.94-5.15,2.97-.69,6.91.42,8.18-3.91,1.48-.88,2.4-2.11,3.05-3.76,3.76-9.52,7.7-18.97,11.46-28.49,7.94-20.1,15.84-40.22,23.68-60.36,3.4-8.75,7.52-17.23,9.79-26.4,1.82-3.12,4.33-4.82,8.09-3.91-15.53,38.86-30.82,77.83-46.6,116.59-2.74,6.67-2.45,7.31,4.86,8.27,9.89,1.41,20.44,3.53,27.51,11.31.01.51.02,1.01.04,1.52-8.63.1-17.25.21-25.88.31-3.03.09-6.17-1-9.04.83Z"
          />
          <path
            className="cls-28"
            d="M204,23.82c4.45-2.77,8.28-1.13,11.86,1.75,4.21,3.39,5.11,8.47,3.31,12.7-1.88,4.44-.4,7.05,1.67,10.41,29.67,47.94,59.32,95.9,88.78,143.97,2.6,4.23,5.39,6.4,10.35,5.58,1.27-.21,2.63.08,3.95.14-.63,1.62-2.06,1.32-3.35,1.43-4.68.39-9.18-.36-13.54-2.08-.8-1.82-1.4-3.76-2.44-5.44-25.86-40.82-50.75-82.24-76.59-123.07-7.07-11.1-12.18-23.64-22.56-32.5-2.02-1.73-2-4.44-1.9-6.94.08-1.99.29-3.97.45-5.95Z"
          />
          <path
            className="cls-11"
            d="M439.95,610.73c.99,0,1.98-.02,2.96-.02,2.42,1.73,5.13,2.13,8.01,1.78,2.32.08,4.65.17,6.97.25.5.7,1.2.92,2.03.84,3.56.23,6.94,1.26,10.31,2.36-1.3,5.04.73,9.82,1.28,14.7.91,8.08,2.37,16.1,3.43,24.17.78,5.88,0,6.64-5.92,6.65-2,0-3.99,0-5.99.01-8.33.03-8.25,0-10.86-7.85-4.65-13.99-9.4-27.95-14.1-41.92.83.07,1.42-.31,1.87-.97ZM470.99,654.96c-.04-.93.13-1.84-.15-2.57-3.5-9.21-6.1-18.75-10.37-27.67-.41-.86-.91-2.02-2.16-1.47-1.54.68-1.24,2.03-.98,3.42,1.78,9.56,4.45,18.93,5.79,28.6.38,2.78,2.59,4.71,5.73,4.34,3.06-.37,1.79-2.98,2.14-4.64Z"
          />
          <path
            className="cls-1"
            d="M204,23.82c-.15,1.98-.37,3.96-.45,5.95-.1,2.5-.12,5.21,1.9,6.94,10.38,8.86,15.48,21.4,22.56,32.5,25.84,40.82,50.73,82.25,76.59,123.07,1.04,1.67,1.64,3.62,2.44,5.44-.89,1.48-1.89,2.67-3.84,1.6-29.04-49.94-60.55-98.49-90.33-148.03-1.96-3.2-4.54-4.96-8.27-5.71-4.71-.96-7.75-5.75-7.9-11.41-.14-5.31,2.23-8.65,7.29-10.33Z"
          />
          <path
            className="cls-1"
            d="M303.21,199.31c1.95,1.08,2.95-.12,3.84-1.6,4.36,1.72,8.86,2.47,13.54,2.08,1.29-.11,2.72.19,3.35-1.43,3.35-.43,6.7-.71,10.03.15,4.63,2.3,9.31,1.52,14.01.26.35.02.7.04,1.05.05-1.27,4.33-5.21,3.22-8.18,3.91-7.63,1.77-15.59,2.02-22.94,5.15-3.67,1.57-6.05,3.5-3.92,7.84-6.25,2.19-12.71.44-19.05,1-5.5-3.22-10.09-7.26-12.19-13.54,1.14-.72,2.36-.9,3.66-.58.98.09,1.93.1,2.52-.9,1.61-1,3.41-.73,5.16-.72.73.82,1.33.64,1.84-.24.97-.78,2.07-.88,3.24-.58.73.67,1.3.43,1.76-.33.76-.18,1.53-.36,2.29-.54Z"
          />
          <path
            className="cls-1"
            d="M349.02,198.83c-.35-.02-.7-.04-1.05-.05,0-.64-.02-1.28-.03-1.92,14.39-39.92,31.29-78.95,46.65-118.52,1.24-3.1,1.62-5.93-.45-8.96-1.06-1.54-2.3-3.36-1.75-5.56,2.59,4.61,7.76,8.55,3.84,14.87-.1.16.5.75.77,1.14-2.27,9.17-6.38,17.65-9.79,26.4-7.84,20.14-15.74,40.26-23.68,60.36-3.76,9.52-7.7,18.97-11.46,28.49-.65,1.65-1.56,2.89-3.05,3.76Z"
          />
          <path
            className="cls-11"
            d="M126.41,568.68c3.21.19,7.43-1.08,9.11,2.08,1.55,2.92-2.35,5.03-3.84,7.47-4.55,7.46-9.42,14.72-14.01,22.15-3.04,4.93-2.47,6.18,3.09,7.25,1.7.33,2.17,1.21,2.33,2.64-1.6,1.26-3.34,1.02-5.11.49-.45-.92-1.17-1.11-2.09-.78-6.39-3.4-7.46-6.69-3.98-13.22,4.12-7.73,8.44-15.35,12.63-23.03.86-1.58,1.98-3.09,1.87-5.04Z"
          />
          <path
            className="cls-28"
            d="M398.82,51.55c13.16-7.2,25.19,9.42,14.63,19.39q-13.42-4.71-13.5-18.11c-.31-.3-.62-.61-.93-.91,0,0-.19-.37-.19-.37Z"
          />
          <path
            className="cls-40"
            d="M282.74,203.19c2.1,6.28,6.69,10.32,12.19,13.54-2.2,1.43-4.4-.1-6.61-.06-8.7.15-17.33.75-25.94,1.99-1.73.25-3.61.62-5.25-.58,4.47-.57,6.86-3.63,9.68-6.87,4.01-4.6,9.72-7.11,15.93-8.01Z"
          />
          <path
            className="cls-28"
            d="M640.62,452.62c-1.08-1.29-.75-2.85-.75-4.32,0-25.31,0-50.63.02-75.94,0-2.12-.45-4.45,2.1-5.65.51,20.56.66,41.1-.54,61.65-.36,6.29-.09,12.62-.17,18.92-.02,1.79.45,3.67-.66,5.33Z"
          />
          <path
            className="cls-28"
            d="M399.95,52.84q.08,13.39,13.5,18.11c-2.15,2.72-5.41,3.58-8.36,4.97-3.77-.91-6.27.79-8.1,3.91-.27-.39-.87-.98-.77-1.14,3.92-6.32-1.25-10.26-3.84-14.87.04-1,.08-2,.12-3,1.79-.69,1.35-2.2,1.3-3.56.31-3.1,2.37-4.66,5.01-5.71,0,0,.2.37.19.37.31.3.62.61.93.92Z"
          />
          <path
            className="cls-28"
            d="M642.06,341.18c-.03-32.3-.4-64.6.01-96.9,1.91,1.85,1.61,4.31,1.6,6.57-.14,28.88-.35,57.77-.54,86.65,0,1.32.09,2.69-1.07,3.68Z"
          />
          <path
            className="cls-9"
            d="M439.95,610.73c-.45.66-1.05,1.04-1.87.97-16.79-2.32-33.58-4.62-50.36-7-1.59-.22-3.33-.08-4.71-1.19,3.13-1.62,6.6-1.2,9.7-.67,10.95,1.88,22.12,2.11,32.96,4.2,4.69.91,10.27-.19,14.29,3.69Z"
          />
          <path
            className="cls-9"
            d="M289.95,590.7c4.33-2.81,8.82-.26,12.97.26,6.72.84,13.62-.27,20.16,1.76,5.69,1.77,11.65,1.95,17.38,3.34,1.33.32,3.09.4,3.5,2.3-8.37-1.04-16.8-1.74-25.1-3.2-9.61-1.69-19.45-1.82-28.9-4.47Z"
          />
          <path
            className="cls-28"
            d="M639.06,548.11c-.06-18.38-.12-36.75-.18-55.13,0-1.33-.11-2.72,1.52-3.3,0,18.28-.02,36.55-.02,54.83,0,1.38-.21,2.65-1.32,3.61Z"
          />
          <path
            className="cls-9"
            d="M443.88,210.72c-9.87,1.91-19.79,2.94-29.82,1.32,9.89-1.51,19.81-2.33,29.82-1.32Z"
          />
          <path
            className="cls-9"
            d="M523.86,207.71c-.72.34-1.45.98-2.17.98-8.13.04-16.25.31-24.36,1.02-1.44.13-3.02.39-4.3-.72,10.24-1.44,20.49-2.44,30.83-1.28Z"
          />
          <path
            className="cls-9"
            d="M235.95,218.77c-.73.33-1.46.93-2.2.95-7.31.13-14.61.05-21.89,1-1.57.2-3.35.5-4.77-.78,9.59-1.08,19.18-2.32,28.86-1.16Z"
          />
          <path
            className="cls-9"
            d="M267.99,587.63c6.21-2.1,12.35-.83,18.46.49,1.03.22,1.37,1.35,1.53,2.38-6.7-.67-13.48-.82-19.99-2.87Z"
          />
          <path
            className="cls-28"
            d="M563.89,211.78c0-.34,0-.68,0-1.02,7.82.42,15.41,2.05,22.88,4.29-5.33,1.68-9.89-2.03-14.96-2.12-.97-.04-1.94-.08-2.9-.12-1.68-.34-3.35-.69-5.03-1.03Z"
          />
          <path
            className="cls-28"
            d="M638.68,234.78c-4.99-5.11-10.55-9.47-16.78-12.97,7.79,1.48,13.48,5.68,16.78,12.97Z"
          />
          <path
            className="cls-9"
            d="M115.04,223.47c-2.3,2.58-5.31,1.07-7.96,1.22-4.13.23-8.29-.07-12.43-.15,6.7-2.25,13.56-1.43,20.4-1.07Z"
          />
          <path
            className="cls-9"
            d="M474.96,209.36c-1.29,2.3-3.51,1.38-5.32,1.35-5.06-.07-10.15.66-15.19-.34,6.78-1.47,13.64-1.38,20.51-1.01Z"
          />
          <path
            className="cls-9"
            d="M193.01,220.38c-2.36,2.75-5.5,1.11-8.26,1.32-3.4.26-6.84-.11-10.27-.22,6.06-2.31,12.31-1.34,18.53-1.1Z"
          />
          <path className="cls-9" d="M145.02,222.39c-5.88,2.58-11.88,1.5-17.88.62,5.95-.63,11.88-1.7,17.88-.62Z" />
          <path className="cls-28" d="M631.02,568.87c3.58-4.91,4.84-10.95,7.82-16.16-.55,6.38-2.01,12.32-7.82,16.16Z" />
          <path
            className="cls-1"
            d="M347.94,196.86c0,.64.02,1.28.03,1.92-4.69,1.25-9.38,2.04-14.01-.26,4.58-1.18,9.56.98,13.98-1.65Z"
          />
          <path
            className="cls-9"
            d="M390.89,213.61c-.01-.51-.02-1.01-.04-1.52,4.04.08,8.08.16,12.12.24-3.77,2.91-8.06.87-12.09,1.28Z"
          />
          <path className="cls-9" d="M369.95,601.66c3.67-1.7,7.06-1.54,10.01,1.53-3.47.38-6.8-.18-10.01-1.53Z" />
          <path className="cls-9" d="M62.16,559.45c3.22-1.45,6.1-.59,8.82,1.3-3.07.42-6.13.85-8.82-1.3Z" />
          <path className="cls-28" d="M609.87,584.44c2.51-3.17,5.45-5.7,9.56-6.51-2.66,2.95-5.9,5.04-9.56,6.51Z" />
          <path className="cls-9" d="M85.12,562.56c2.96-1.61,5.49-.56,7.87,1.31-2.76.38-5.56.99-7.87-1.31Z" />
          <path
            className="cls-9"
            d="M553.82,209.03c-.79.89-1.86.7-2.87.72-1.63-1.88-4.62.13-6.12-2.14,3.19-.73,6.24-.65,8.99,1.42Z"
          />
          <path className="cls-9" d="M564.92,615.73c1.68-3.38,4.43-5.3,8.1-5.98-2.19,2.68-4.85,4.73-8.1,5.98Z" />
          <path className="cls-9" d="M107.98,565.8c3.07.11,6.32-1.16,9.09,1.21-3.14.39-6.29.9-9.09-1.21Z" />
          <path className="cls-9" d="M529.62,623.92c3.16-.02,6.48-1.51,9.35,1.05-3.19.26-6.43,1.06-9.35-1.05Z" />
          <path className="cls-28" d="M613.8,220.01c-2.65,1.15-5.17,1.66-6.95-1.43,2.56-.69,4.83-.01,6.95,1.43Z" />
          <path className="cls-9" d="M155.95,221.86c-2.89,1.54-5.83,1.26-8.79.22,2.91-1.08,5.85-.74,8.79-.22Z" />
          <path className="cls-9" d="M347.99,598.56c2.99-1.6,5.67-1.32,7.95,1.32-2.77.29-5.48.19-7.95-1.32Z" />
          <path className="cls-28" d="M600.88,590.54c1.75-2.55,3.56-5.01,7.17-4.78-1.93,2.29-4.39,3.77-7.17,4.78Z" />
          <path className="cls-9" d="M518.05,622.29c2.9-1.37,5.38-.19,7.79,1.32-2.77.59-5.36.07-7.79-1.32Z" />
          <path className="cls-9" d="M483,617.5c2.88-1.1,5.41-.05,7.89,1.29-2.85.93-5.41.03-7.89-1.29Z" />
          <path className="cls-28" d="M621.85,576.32c.86-3.04,3.25-4.1,6.04-4.62-1.54,2.15-3.48,3.79-6.04,4.62Z" />
          <path className="cls-9" d="M540.84,624.94c2.17-2.4,4.85-1.1,7.37-1.01-2.22,2.06-4.83,1.28-7.37,1.01Z" />
          <path className="cls-28" d="M641.91,242.77c-2.84-1.62-2.15-4.7-2.95-7.17,1.89,2.02,3.11,4.31,2.95,7.17Z" />
          <path className="cls-9" d="M360.09,600.34c2.46-.59,5.07-2.07,6.87,1.18-2.35-.04-4.78.41-6.87-1.18Z" />
          <path className="cls-28" d="M603.7,218.22c-2.43.5-5,1.87-6.83-1.16,2.38-.23,4.77-.52,6.83,1.16Z" />
          <path className="cls-9" d="M119.17,567.33c2.18-.77,4.36-1.56,5.91,1.09-2.08.23-4.12.23-5.91-1.09Z" />
          <path className="cls-9" d="M73.71,561c2.2-.09,4.6-1.34,6.36,1.11-2.25.37-4.5.78-6.36-1.11Z" />
          <path className="cls-9" d="M562.34,210.55c-2.23-.08-4.79,1.41-6.48-1.32,2.32-.34,4.61-.52,6.48,1.32Z" />
          <path className="cls-9" d="M507.66,620.89c2.18-.17,4.46-1.03,6.32.94-2.25.66-4.43.85-6.32-.94Z" />
          <path className="cls-28" d="M583.87,602.32c.69-2.67,2.84-3.24,5.15-3.57-1.17,1.98-3.05,2.94-5.15,3.57Z" />
          <path className="cls-9" d="M96.54,564.15c1.96-.23,4.12-1.46,5.5,1.12-1.96.25-3.95.66-5.5-1.12Z" />
          <path className="cls-9" d="M494.39,619.14c1.99-.33,4.14-1.48,5.56,1.1-2,.38-3.9.24-5.56-1.1Z" />
          <path className="cls-28" d="M594.31,216.59c-1.58.13-3.28.77-4.44-1.01,1.69-.61,3.18-.29,4.44,1.01Z" />
          <path className="cls-28" d="M593.88,595.42c.43-1.88,1.94-2.39,3.54-2.79-.72,1.52-1.75,2.63-3.54,2.79Z" />
          <path className="cls-28" d="M578.96,605.26c1.11-1.36,2.22-2.72,4.28-2.42-1.02,1.52-2.32,2.55-4.28,2.42Z" />
          <path className="cls-9" d="M64.04,225.22c-.87,2.14-2.29,1.82-3.86.86,1.07-1.26,2.45-1.1,3.86-.86Z" />
          <path className="cls-9" d="M540.72,207.23c-1.37.89-2.79.59-4.22.2,1.35-1.17,2.75-1.49,4.22-.2Z" />
          <path className="cls-9" d="M473.65,615.94c1.58-.19,3.28-.86,4.32,1.09-1.69.63-3.18.44-4.32-1.09Z" />
          <path className="cls-28" d="M620.31,221.58c-1.63.07-3.49.91-4.46-1.3,1.7-.31,3.24-.06,4.46,1.3Z" />
          <path className="cls-28" d="M627.9,571.7c.15-1.95,1.13-2.99,3.16-2.87-.51,1.56-1.6,2.47-3.16,2.87Z" />
          <path
            className="cls-36"
            d="M573.84,609.36c.02-.89.04-1.78.06-2.68.95,0,1.9,0,2.85-.01-.27,1.66-1.43,2.35-2.92,2.69Z"
          />
          <path className="cls-9" d="M56.84,557.91c1.37-.31,2.64-.35,3.21,1.31-1.41.4-2.46-.1-3.21-1.31Z" />
          <path className="cls-9" d="M57.06,226.58c-.78,1.46-2.05,1.26-3.34.99.85-1.2,1.97-1.52,3.34-.99Z" />
          <path className="cls-8" d="M393.81,57.26c.05,1.36.49,2.87-1.3,3.56-.37-1.48.15-2.63,1.3-3.56Z" />
          <path className="cls-13" d="M115.89,609.97c.92-.33,1.64-.13,2.09.78-1,.55-1.68.24-2.09-.78Z" />
          <path className="cls-1" d="M288.92,201.71c-.59,1.01-1.54,1-2.52.9.64-.84,1.38-1.43,2.52-.9Z" />
          <path className="cls-1" d="M295.92,200.75c-.51.88-1.11,1.07-1.84.24.55-.57,1.15-.72,1.84-.24Z" />
          <path className="cls-9" d="M561.88,617.5c.27-1.43,1.18-1.83,2.5-1.56-.52,1.02-1.26,1.7-2.5,1.56Z" />
          <path className="cls-1" d="M300.92,199.85c-.47.76-1.03,1-1.76.33.49-.63,1.08-.74,1.76-.33Z" />
          <path className="cls-28" d="M589.87,598.32c.23-1.23,1.02-1.65,2.19-1.56-.47.89-1.13,1.5-2.19,1.56Z" />
          <path className="cls-9" d="M554.84,622.01c.41-1.04,1.2-1.36,2.25-1.22-.44.98-1.12,1.51-2.25,1.22Z" />
          <path
            className="cls-9"
            d="M550.89,623.45c.04-.56.07-1.12.11-1.68.62.26,1.23.51,1.85.77-.44.77-1.07,1.11-1.96.91Z"
          />
          <path className="cls-36" d="M54.99,556.79c.33.16.67.31,1,.47-.33-.16-.67-.31-1-.47Z" />
          <path
            className="cls-7"
            d="M550.89,570.62c0-10.33.54-20.69-.1-30.98-2.78-48.26-1.38-96.59-2.8-144.89.03-18.22,1.4-36.47.68-54.64-.77-19.3.2-38.62-1-57.85-.91-14.65-.37-29.26-.75-43.88-.85-12.81,14.08-24.44,22.37-10.38,1.52,2.67,2.69,5.61,2.68,8.97.41,35.14-.34,70.25-1.11,105.33-1.46,60.32-1.15,120.67-2.17,180.95-.43,11.47-1.24,22.97-.56,34.37.81,13.47-.87,26.85-.31,40.28.31,7.39-4.48,11.82-11.11,11.81-4.31,0-5.9-1.95-5.85-6.13.13-10.99.04-21.99.04-32.98Z"
          />
          <path
            className="cls-7"
            d="M594.92,311.74c2.65,0,5.3-.01,7.94,0,1.39.01,2.7.21,2.94,1.96.67,2.8-2.2,5.3-4.42,2.94-2.47-2.51-5.41-2.18-8.33-1.41-2.79.74-5.59.45-8.39.49-1.32.02-3.02-.02-3.11-1.68-.1-1.77,1.89-1.8,2.98-1.92,3.44-.38,6.92-.39,10.38-.55,0,.05,0,.11,0,.16Z"
          />
          <path
            className="cls-7"
            d="M601.69,372.41c-4.8-1.59-9.38.54-14.07.89-1.63.12-3.27.28-4.9.31-1.91,0-1.95-2.58-.02-2.75,6.42-1.25,12.75-3.06,19.36-3.11,1.67-.01,3.64.1,3.32,2.52-.26,1.95-1.7,2.71-3.68,2.15Z"
          />
          <path className="cls-28" d="M568.92,212.82c.97.04,1.94.08,2.9.12-.17,2.25-2.75,2.2-2.9-.12Z" />
          <path
            className="cls-24"
            d="M71.01,538.89c-1.66-.05-3.32-.11-4.97-.16-.98-1.2-1.99-1.18-3.02-.06-4.93-1.09-7.32-3.92-7.06-9.19.33-88.92-3.22-177.79-3.09-266.69.75-2.02-1.19-4.95,2.05-6.14,1.33,4.37,1.38,9.28,5.19,13.4.68-5.68,2.7-7.55,5.47-5.8,1.93,1.22,1.25,3.25,1.58,4.97.34,1.77,1.47,2.57,3.19,2.42,1.5-.13,2.54-.87,2.21-2.6-.96-5.09,2.12-3.19,3.85-1.93,2.54,1.85,4.28,1.54,6.47-.51,3.18-2.98,7.39-3.42,11.52-3.83,1.98-.19,3.75.09,3.68,2.74-6.93,3.32-13.47,7.04-18.29,13.4-9.76,12.88-13.71,27.65-13.66,43.4.09,48.41,1.94,96.82,1.69,145.26-.44,29.91,11.12,66.26,45.84,69.85,53.82,5.62,107.41,13.04,161.14,19.41,10.38,1.28,20.75,2.63,31.12,3.94,6.94.88,13.46-1.16,20.04-2.82-.46,2.77-3.19,3.16-4.88,4.63-1.09.95-3,1.5-2.49,3.28.46,1.62,2.35,1.45,3.76,1.9,4.04,1.3,8.33.37,12.34,1.43,10.96,2.89,22.35,2.25,33.45,4.36,9.73,1.85,19.84,1.67,29.58,3.48,17.76,3.29,35.79,4.39,53.57,7.48,14.5,2.51,29.27,3.43,43.87,5.41,3.02.41,6.95-.12,8.69,3.73-.67.04-1.33.07-2,.11-24.63-3.3-49.29-6.33-73.97-9.13-46.23-6.5-92.64-11.73-138.92-17.92-27.09-3.64-54.19-7.11-81.36-10.07-21.54-2.61-42.91-6.63-64.58-7.96-1.62-.01-3.24-.03-4.86-.04-1.34-3.1-4.02-1.51-6.18-1.77-6.09.16-11.98-1.34-17.96-2.08-1.78-1.79-3.99-.84-6.04-.97-6.08.12-12.11-.19-17.98-2-1.42-1.62-3.27-.95-4.99-.94-3.61-.08-7.21-.16-10.82-.24-.43-1.73-1.66-1.99-3.17-1.72Z"
          />
          <path
            className="cls-24"
            d="M514.89,243.96c2.26,2.87,3.06,6.12,3.05,9.77.26,60.61-.75,121.24-1.31,181.82-1.08,29.81-.03,59.61-.78,89.39-.5,19.8-1.03,39.59-.81,59.39.03,3.12-.74,5.6-4.03,6.62-7.84,0-9.34-2.23-9.93-11,2.42-34.1.29-68.46,1.59-102.67.52-72.19,1.49-144.41,1.19-216.62-.03-6.05-.22-11.97,4.31-16.77.94-.14,1.89-.29,2.83-.43,1.3.17,2.59.33,3.89.5Z"
          />
          <path
            className="cls-24"
            d="M511,243.47c-.94.14-1.89.29-2.84.43-4.55-.35-8.72,1.88-13.23,1.87-22.24-.06-44.44.71-66.65,1.92-12.92.71-25.87.37-38.82.79-17.74.57-35.49,2-53.27,1.3-2.54-.1-5.53-.1-6.58,2.45-.98,2.39,2,3.48,3.37,4.98,3.86,4.23,9.06,7.67,7.95,14.59-2.37-.62-4.39-1.94-6.55-2.99-4.01-1.95-7.48-5.36-12.37-5.24-1.53-1.44-3.47-.77-5.23-1.01-12.41-1.73-24.82-.29-37.24-.04-40.56.8-81.14,1.16-121.71,1.45-19.93.19-39.88-.44-59.76,1.53.07-2.65-1.7-2.93-3.68-2.74-4.13.4-8.34.85-11.52,3.83-2.19,2.05-3.93,2.36-6.47.51-1.72-1.26-4.81-3.16-3.85,1.93.33,1.73-.71,2.47-2.21,2.6-1.72.15-2.85-.65-3.19-2.42-.33-1.72.35-3.75-1.58-4.97-2.77-1.75-4.8.12-5.47,5.8-3.81-4.13-3.86-9.04-5.19-13.4.64-3.01,2.74-3.91,5.54-3.88,16.8.18,33.56-1.21,50.37-1.16,73.93-1.46,147.93-3.26,221.9-5.07,43.39-1.11,86.76-2.91,130.14-2.92,6.37.04,12.75.09,19.12.11,1.6,0,3.39.31,4.04-1.83,7.57.02,15.14-.42,22.71.3,1.11.11,1.9.11,2.27,1.26Z"
          />
          <path
            className="cls-9"
            d="M486.02,241.91c-.65,2.14-2.44,1.83-4.04,1.83-6.37-.02-12.75-.07-19.12-.11.62-2.19,2.43-1.84,4.02-1.84,6.38.02,12.76.07,19.14.12Z"
          />
          <path className="cls-9" d="M325.97,215.71c3.31-1.48,6.64-1.34,9.97-.08-3.31,1.81-6.64,1.66-9.97.08Z" />
          <path className="cls-9" d="M355.97,214.76c2.87-1.83,6.01-.74,9.04-.83-2.74,3.23-5.9,1.95-9.04.83Z" />
          <path className="cls-9" d="M316.99,215.82c.61-.93,1.27-.96,1.97-.1-.61.93-1.26,1.01-1.97.1Z" />
          <path
            className="cls-24"
            d="M340.93,271.8c1.11-6.92-4.09-10.36-7.95-14.59-1.37-1.5-4.35-2.59-3.37-4.98,1.05-2.54,4.04-2.55,6.58-2.45,17.78.69,35.53-.73,53.27-1.3,12.94-.42,25.9-.08,38.82-.79,22.2-1.21,44.41-1.98,66.65-1.92,4.51.01,8.68-2.22,13.23-1.87-4.53,4.8-4.34,10.72-4.31,16.77.3,72.21-.67,144.43-1.19,216.62-1.31,34.21.82,68.58-1.59,102.67.59,8.78,2.09,11.01,9.93,11-1.68,2.78-4.48,2.56-7.16,2.67-1.75-3.86-5.68-3.32-8.69-3.73-14.6-1.98-29.37-2.9-43.87-5.41-17.79-3.08-35.82-4.18-53.57-7.48-9.74-1.81-19.85-1.63-29.58-3.48-11.09-2.11-22.48-1.47-33.45-4.36-4.01-1.06-8.29-.13-12.34-1.43-1.4-.45-3.3-.29-3.76-1.9-.51-1.78,1.4-2.33,2.49-3.28,1.69-1.47,4.42-1.87,4.88-4.64,5.48-2.84,11.89-4.05,16.02-9.23,15.67-12.12,21.49-29.27,21.69-47.85.6-57.6.31-115.22.17-172.83-.33-22.86-7.6-39.51-22.9-56.22ZM391.94,340.78c.02.63.04,1.26.05,1.89.01,1.27.65,1.97,1.91,2.09,1.97,6.99,6.72,12.08,11.84,16.8,10.45,9.64,23.31,10.11,36.45,9.01,1.82-.15,4.11-.32,4.83-2.77,7.72-1.76,14.62-5.01,19.97-11.05,4.42-3.39,7.86-7.48,10.09-12.7,6.75-14.67,8.05-32.33.65-46.97-9.02-17.88-30.75-32.87-51.18-26.59-15.05,4.39-25.56,14.53-33.22,27.59-3.04,5.17-6.31,11.05-3.43,17.71,0,.97,0,1.95,0,2.92-3.5,2.33-2.11,5.21-.92,8.07v2.88c.56,2.4-1.61,5.53,1.94,7.11.02.64.03,1.27.05,1.91,0,.85.23,1.59.97,2.09ZM380.95,539.46c0,9.8.55,11.6,5.97,11.86,9.96.48,19.7,2.75,29.59,3.25,11.43.58,22.81,2.04,34.04,3.65,11.27,1.62,22.76,1.4,33.91,4.27,5.47,1.41,7.57-.9,7.35-6.67-.12-3.07-.22-6.36-1.94-9.07-1.05-1.66-.37-2.6.41-3.98,2.8-4.95,2.44-10.21.28-15.17-.76-1.74-1.08-2.54.03-4.25,2.72-4.22,1.2-9.02,1.02-13.57-.07-1.71-1.94-2.12-3.52-2.05-8.16.36-15.96-2.66-24.23-2.26-4.16.2-8.56-.58-12.84-.98-12.84-1.2-25.72-2.14-38.49-3.91-8.41-1.16-16.92-.03-25.25-1.96-5.1-1.18-6.1-.15-6.34,5.06-.3,6.57.98,13.23-1.74,19.69-.81,1.93-.56,4.82.27,6.83,1.41,3.38,1.58,6.75,1.48,9.27ZM464.9,403.63c-.05-5.87-3.89-9.82-9.51-9.77-13.54.64-13.8,19.56.15,19.67,5.6-.06,9.41-4.09,9.36-9.89ZM427.93,402.22c0-6.36-2.83-9.41-8.77-9.48-13.56-.19-13.51,19.15-.08,18.97,5.88-.07,8.85-3.25,8.85-9.49Z"
          />
          <path className="cls-9" d="M450.93,612.49c-2.88.35-5.59-.05-8.01-1.78,2.87-.32,5.87-1.22,8.01,1.78Z" />
          <path
            className="cls-9"
            d="M138.15,548.61c1.62.01,3.24.03,4.86.04-2.32,3.24-4.65,3.21-7,.03.71-.03,1.42-.05,2.14-.08Z"
          />
          <path
            className="cls-9"
            d="M138.15,548.61c-.71.03-1.42.05-2.14.08-1.33,0-2.66,0-4,0-.01-.61-.03-1.23-.05-1.84,2.15.26,4.84-1.33,6.18,1.77Z"
          />
          <path className="cls-9" d="M459.93,613.58c-.83.08-1.53-.14-2.03-.84,1.4-1.46,1.75-.39,2.03.84Z" />
          <path className="cls-9" d="M107.98,543.79c2.04.13,4.26-.82,6.04.97-2.23,1.05-4.48,2.15-6.04-.97Z" />
          <path className="cls-9" d="M85,540.85c1.73-.01,3.58-.68,4.99.94-1.95,1.2-3.79,1.84-4.99-.94Z" />
          <path className="cls-9" d="M71.01,538.89c1.51-.27,2.74,0,3.17,1.72-1.42.1-2.81.13-3.17-1.72Z" />
          <path className="cls-9" d="M63.01,538.67c1.03-1.12,2.04-1.14,3.02.06-1.03,1.17-2.04,1.14-3.02-.06Z" />
          <path
            className="cls-13"
            d="M470.99,654.96c-.35,1.66.92,4.27-2.14,4.64-3.15.38-5.35-1.55-5.73-4.34-1.34-9.66-4.01-19.04-5.79-28.6-.26-1.39-.56-2.73.98-3.42,1.25-.55,1.74.61,2.16,1.47,4.26,8.92,6.87,18.46,10.37,27.67.28.74.11,1.64.15,2.57Z"
          />
          <path className="cls-8" d="M399.95,52.84c-.31-.31-.62-.61-.93-.92.31.31.62.61.93.92Z" />
          <path
            className="cls-11"
            d="M341.98,548.7c-4.13,5.18-10.54,6.39-16.02,9.23-6.58,1.67-13.11,3.7-20.04,2.83-10.37-1.31-20.74-2.66-31.12-3.94-53.73-6.37-107.32-13.79-161.14-19.41-34.73-3.58-46.28-39.94-45.84-69.85.25-48.43-1.6-96.85-1.69-145.26-.05-15.75,3.9-30.52,13.66-43.4,4.81-6.35,11.35-10.07,18.29-13.4,19.88-1.97,39.83-1.34,59.76-1.53,40.57-.3,81.14-.65,121.71-1.45,12.42-.26,24.82-1.7,37.24.04,1.76.25,3.7-.42,5.23,1.01-.23,2.32.93,4.11,2.13,5.95,22.18,32.75,18.8,62.06,19.4,99.02-.34,41.46-1.02,83.14-1.53,124.66-.09,5.99-.89,11.88-1.67,17.78-1.57,11.94-6.21,22.87-11.33,33.63-1.02,2.14-2.16,4.75-.1,6.43,1.78,1.45,4.46,1.06,6.54-.39,1.98-1.39,4.08-2.21,6.53-1.95Z"
          />
          <path
            className="cls-14"
            d="M341.98,548.7c-2.45-.25-4.55.57-6.53,1.95-2.08,1.45-4.75,1.85-6.54.39-2.06-1.68-.92-4.29.1-6.43,5.12-10.76,9.76-21.69,11.33-33.63.78-5.9,1.58-11.79,1.67-17.78.51-41.51,1.2-83.19,1.53-124.66-.61-36.95,2.77-66.27-19.4-99.02-1.2-1.85-2.36-3.63-2.13-5.95,4.89-.12,8.36,3.29,12.37,5.24,2.16,1.05,4.19,2.37,6.55,2.99,15.3,16.71,22.58,33.35,22.9,56.22.14,57.61.43,115.22-.17,172.83-.19,18.59-6.02,35.74-21.69,47.85Z"
          />
          <path
            className="cls-14"
            d="M380.95,539.46c.09-2.52-.07-5.88-1.48-9.27-.83-2.01-1.09-4.89-.27-6.83,2.72-6.46,1.44-13.12,1.74-19.69.24-5.21,1.25-6.23,6.34-5.06,8.33,1.92,16.84.79,25.25,1.96,12.76,1.77,25.65,2.71,38.49,3.91,4.28.4,8.68,1.18,12.84.98,8.26-.4,16.06,2.63,24.23,2.26,1.58-.07,3.45.34,3.52,2.05.17,4.55,1.7,9.35-1.02,13.57-1.1,1.71-.79,2.51-.03,4.25,2.17,4.96,2.52,10.22-.28,15.17-.79,1.39-1.47,2.32-.41,3.98,1.72,2.71,1.82,6,1.94,9.07.22,5.77-1.88,8.08-7.35,6.67-11.15-2.88-22.64-2.65-33.91-4.27-11.22-1.61-22.6-3.08-34.04-3.65-9.89-.5-19.63-2.77-29.59-3.25-5.42-.26-5.97-2.06-5.97-11.86Z"
          />
          <path
            className="cls-11"
            d="M466.98,356.74c-5.35,6.05-12.24,9.3-19.97,11.05-4.15-.02-8.32-.22-12.46,0-5.68.29-11-1.39-15.7-3.94-17.09-9.27-25.07-24.24-25.95-43.4-.28-6.05,1.69-11.77,2.04-17.71,5.85-11.4,13.02-21.29,25.27-27.01,15.83-7.39,29.85-4.3,39.6,9.77,8.09,9.19,13.72,19.8,14.06,32.17.57,12.76-3.21,24.24-11.46,34.12-.63.76-1.47,1.48-.9,2.61,1.41,2.72,4.69-1.69,5.47,2.34ZM460.93,319.54c-.03-7.92-2.27-14.96-8.24-20.51-1.44-1.34-3.05-3.37-5.03-1.55-1.76,1.62.02,3.24,1.14,4.69,7.63,9.22,8.59,24.4,1.16,34.16-.83,1.11-1.65,2.58-.47,3.56,1.45,1.21,2.27-.65,3.16-1.44,5.67-5.01,8.35-11.36,8.27-18.92Z"
          />
          <path
            className="cls-14"
            d="M466.98,356.74c-.78-4.04-4.06.38-5.47-2.34-.57-1.13.27-1.85.9-2.61,8.25-9.88,12.04-21.36,11.46-34.12-.34-12.38-5.97-22.99-14.06-32.17-9.76-14.07-23.77-17.16-39.6-9.77-12.25,5.72-19.42,15.61-25.27,27.01-4.13,3.4-2.99,8.85-5.05,13.05-2.88-6.66.39-12.54,3.43-17.71,7.67-13.06,18.17-23.21,33.22-27.59,20.44-6.28,42.16,8.72,51.18,26.59,7.4,14.63,6.1,32.3-.65,46.97-2.24,5.22-5.67,9.31-10.09,12.7Z"
          />
          <path
            className="cls-40"
            d="M389.89,315.79c2.06-4.2.92-9.65,5.05-13.05-.34,5.94-2.32,11.66-2.04,17.71.88,19.16,8.86,34.13,25.95,43.4,4.71,2.55,10.03,4.23,15.7,3.94,4.14-.21,8.3,0,12.46,0-.72,2.46-3,2.62-4.83,2.77-13.14,1.1-26,.63-36.45-9.01-5.12-4.72-9.87-9.81-11.84-16.8-.03-1.26-.7-1.92-1.91-2.09-.02-.63-.04-1.26-.05-1.89-.32-.7-.65-1.39-.97-2.09-.02-.64-.03-1.27-.05-1.91-.56-2.39,1.52-5.5-1.93-7.11,0-.96,0-1.92-.01-2.88,1.83-2.52.65-5.38.92-8.07,0-.97,0-1.95,0-2.92Z"
          />
          <path
            className="cls-30"
            d="M464.9,403.63c.05,5.8-3.76,9.83-9.36,9.89-13.95-.1-13.68-19.03-.15-19.67,5.62-.04,9.45,3.9,9.51,9.77Z"
          />
          <path
            className="cls-6"
            d="M427.93,402.22c0,6.24-2.97,9.43-8.85,9.49-13.44.17-13.48-19.17.08-18.97,5.94.07,8.77,3.13,8.77,9.48Z"
          />
          <path className="cls-40" d="M389.9,318.71c-.27,2.7.91,5.56-.92,8.07-1.19-2.86-2.58-5.75.92-8.07Z" />
          <path className="cls-40" d="M388.99,329.67c3.45,1.61,1.37,4.72,1.93,7.11-3.56-1.58-1.38-4.71-1.93-7.11Z" />
          <path className="cls-40" d="M391.99,342.67c1.21.17,1.89.84,1.91,2.09-1.26-.13-1.9-.83-1.91-2.09Z" />
          <path className="cls-40" d="M390.97,338.69c.32.7.65,1.39.97,2.09-.74-.5-.97-1.24-.97-2.09Z" />
          <path
            className="cls-14"
            d="M460.93,319.54c.09,7.56-2.59,13.91-8.27,18.92-.89.79-1.72,2.64-3.16,1.44-1.18-.99-.36-2.45.47-3.56,7.42-9.75,6.47-24.93-1.16-34.16-1.12-1.45-2.9-3.07-1.14-4.69,1.97-1.82,3.58.21,5.03,1.55,5.97,5.55,8.21,12.59,8.24,20.51Z"
          />
        </g>
      </g>
    </StyledSVG>
  );
};

export default TV_OMD_3D;
